import { firestore, firebaseApp } from '../main';
import axios from 'axios';
import config from '../config';

export default {
  namespaced: true,
  state: {
    leaderboard: [],
    isReceiving: false
  },
  mutations: {
    RECEIVED_LEADERBOARD(state, payload) {
      state.leaderboard = payload;
      state.isReceiving = false;
    },
    RECEIVING_LEADERBOARD(state) {
      state.isReceiving = true;
    }
  },
  actions: {
    async refreshGeneralLeaderboard({ dispatch }, payload) {
      dispatch('receivingLeaderboard');
      firebaseApp
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios.post(`${config.baseURLApi}/refresh-general-scores`).then(async res => {
            const leaderboardSnapshot = await firestore
              .collection('scores')
              .where('general', '==', true)
              .orderBy('score', 'desc')
              .get();

            const leaderboard = leaderboardSnapshot.docs.map(doc => Object.assign({}, doc.data(), { id: doc.id }));
            dispatch('receiveLeaderboard', leaderboard);
          });
        })
        .catch(function(error) {
          console.error(error);
          dispatch('receiveLeaderboard', []);
          payload.$toasted.error('Leaderboard could not be refreshed!');
        });
    },
    async getLeaderboardRequest({ dispatch }, payload) {
      dispatch('receivingLeaderboard');

      const behaviourId = payload.behaviourId;
      const countries = payload.countryIds;
      const snapshot =
        behaviourId != null
          ? await firestore
              .collection('scores')
              .where('behaviourId', '==', behaviourId)
              .where('active', '==', true)
              .orderBy('score', 'desc')
              .get()
          : await firestore
              .collection('scores')
              .where('general', '==', true)
              .where('active', '==', true)
              .orderBy('score', 'desc')
              .get();
      let leaderboard = snapshot.docs.map(doc => Object.assign({}, doc.data(), { id: doc.id }));
      if (behaviourId == null) {
        leaderboard = leaderboard.filter(score => countries.includes(score.tenantId));
      }
      for (let i in leaderboard) {
        leaderboard[i].place = i == 0 ? 1 : leaderboard[i - 1].score == leaderboard[i].score ? leaderboard[i - 1].place : parseInt(i) + 1;
      }
      debugger;
      dispatch('receiveLeaderboard', leaderboard);
    },
    receiveLeaderboard({ commit }, payload) {
      commit('RECEIVED_LEADERBOARD', payload);
    },
    receivingLeaderboard({ commit }) {
      commit('RECEIVING_LEADERBOARD');
    }
  }
};
